export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '排气压力(MPa)',
    en: 'Exhaust Pressure(MPa)',
    dataIndex: 'exhaustPressure',
    key: 'exhaustPressure'
  },
  {
    zh: '排气温度(℃)',
    en: 'Exhaust Temperature(℃)',
    dataIndex: 'exhaustTemperature',
    key: 'exhaustTemperature'
  },
  {
    zh: '进气温度(℃)',
    en: 'Inlet Temperature',
    dataIndex: 'inletTemperature',
    key: 'inletTemperature'
  },
  {
    zh: '频率(Hz)',
    en: 'Output Frequency(Hz)',
    dataIndex: 'outputFrequency',
    key: 'outputFrequency'
  },
  {
    zh: '上限频率(Hz)',
    en: 'Rated Frequency(Hz)',
    dataIndex: 'ratedFrequency',
    key: 'ratedFrequency'
  },
  {
    zh: '主机转速(%)',
    en: 'Machine Speed',
    dataIndex: 'machineSpeed',
    key: 'machineSpeed'
  }
]